import React from 'react';
import classNames from 'classnames';
import Box from '../box/box.jsx';
import Monitor from '../../containers/monitor.jsx';
import PropTypes from 'prop-types';
import {OrderedMap} from 'immutable';
import {stageSizeToTransform} from '../../lib/screen-utils';
import layoutConstant from '../../lib/layout-constants.js';
import {ScratchBlocks} from '@hetao/scratch-core';

import styles from './monitor-list.css';

const Blockly = ScratchBlocks;
const MonitorList = props => (
    <Box
        // Use static `monitor-overlay` class for bounds of draggables
        className={classNames(styles.monitorList, 'monitor-overlay')}
        style={{
            width: props.isFullScreen ? props.stageSize.width : layoutConstant.standardStageWidth,
            height: props.isFullScreen ? props.stageSize.height : layoutConstant.standardStageHeight
        }}
    >
        <Box
            className={styles.monitorListScaler}
            style={stageSizeToTransform(props.stageSize)}
        >
            {props.monitors.valueSeq().filter(m => {
                if (Blockly._variableNameIgnoreRegex &&
                    Blockly._variableNameIgnoreRegex.test(m.params.VARIABLE || m.params.LIST)) {
                    return false;
                }
                return m.visible;
            })
                .map(monitorData => (
                    <Monitor
                        draggable={props.draggable}
                        dx={monitorData.dx}
                        dy={monitorData.dy}
                        height={monitorData.height}
                        id={monitorData.id}
                        isFullScreen={props.isFullScreen}
                        key={monitorData.id}
                        max={monitorData.sliderMax}
                        min={monitorData.sliderMin}
                        mode={monitorData.mode}
                        opcode={monitorData.opcode}
                        params={monitorData.params}
                        spriteName={monitorData.spriteName}
                        stageSize={props.stageSize}
                        targetId={monitorData.targetId}
                        value={monitorData.value}
                        width={monitorData.width}
                        x={monitorData.x}
                        y={monitorData.y}
                        onDragEnd={props.onMonitorChange}
                    />
                ))}
        </Box>
    </Box>
);

MonitorList.propTypes = {
    draggable: PropTypes.bool.isRequired,
    isFullScreen: PropTypes.bool.isRequired,
    monitors: PropTypes.instanceOf(OrderedMap),
    onMonitorChange: PropTypes.func.isRequired,
    stageSize: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
        widthDefault: PropTypes.number,
        heightDefault: PropTypes.number
    }).isRequired
};

export default MonitorList;
